// extracted by css-extract-rspack-plugin
var _1 = "gRVCQFck_rJaAPKG";
export { _1 as "pageSeparator" }
// extracted by css-extract-rspack-plugin
var _1 = "gRVCQFck_rJaAPKG";
export { _1 as "pageSeparator" }
